import ChartController from "./chart_controller"

export default class extends ChartController {
  static values = {
    otherText: { type: String, default: "Other" },
    tooltipLabelText: { type: String, default: "%{label}: %{value} views (%{percentage}%)" },
  };
  createChart(ctx) {
    return this.createPieChart(ctx)
  }

  createPieChart(ctx) {
    const labels = this.extractPieChartLabels()
    const data = this.extractPieChartData()
    const baseOptions = this.getBaseChartOptions()

    return new this.Chart(ctx, {
      type: "pie",
      data: {
        labels: labels,
        datasets: [this.createPieDataset(data)]
      },
      options: {
        ...baseOptions,
        plugins: {
          legend: this.createPieLegendConfig(),
          tooltip: this.createPieTooltipConfig()
        },
        interaction: {
          intersect: true,
          mode: "point"
        },
        animation: {
          ...baseOptions.animation,
          animateRotate: true,
          animateScale: true
        },
        layout: this.getDefaultLayout(10)
      }
    })
  }

  extractPieChartLabels() {
    return this.dataValue.map(item => {
      return item.country?.name || this.otherTextValue
    })
  }

  extractPieChartData() {
    return this.dataValue.map(item => item.count || item.percentage || 0)
  }

  createPieDataset(data) {
    return {
      data: data,
      backgroundColor: this.getPieChartColors(),
      borderColor: "rgba(255, 255, 255, 1)",
      borderWidth: 2
    }
  }

  getPieChartColors() {
    return [
      "rgba(37, 99, 235, 0.8)",
      "rgba(16, 185, 129, 0.8)",
      "rgba(245, 158, 11, 0.8)",
      "rgba(239, 68, 68, 0.8)",
      "rgba(139, 92, 246, 0.8)",
      "rgba(236, 72, 153, 0.8)",
      "rgba(20, 184, 166, 0.8)",
      "rgba(251, 146, 60, 0.8)",
      "rgba(34, 197, 94, 0.8)",
      "rgba(59, 130, 246, 0.8)"
    ]
  }

  createPieLegendConfig() {
    return {
      position: "right",
      labels: {
        color: "rgba(107, 114, 128, 0.9)",
        font: { size: 12 },
        padding: 15,
        usePointStyle: true,
        pointStyle: "circle"
      }
    }
  }

  createPieTooltipConfig() {
    const total = this.dataValue.reduce((sum, item) => sum + (item.count || item.percentage || 0), 0)
    
    return {
      enabled: true,
      backgroundColor: "rgba(17, 24, 39, 0.9)",
      titleColor: "rgba(255, 255, 255, 1)",
      bodyColor: "rgba(255, 255, 255, 1)",
      borderColor: "rgba(37, 99, 235, 1)",
      borderWidth: 1,
      padding: 12,
      cornerRadius: 8,
      displayColors: true,
      callbacks: {
        label: (context) => {
          const label = context.label || ""
          const value = context.parsed || 0
          const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : "0.0"
          return this._interpolate(this.tooltipLabelTextValue, { label: label, value: value, percentage: percentage })
        }
      }
    }
  }
}

